'use client';

import ErrorContent from '@hen-site/component/ErrorContent';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  console.error('[Page Error]', error);

  return (
    <main className='px-page-sides pt-page-top pb-page-bottom'>
      <div className='max-w-content mx-auto'>
        <ErrorContent statusCode={500}>
          <button
            onClick={reset}
            className='mt-6 rounded-md bg-primary px-6 py-2 text-white hover:opacity-90'
          >
            Try again
          </button>
        </ErrorContent>
      </div>
    </main>
  );
}
